export default __webpack_public_path__ + "static/media/close-eye.030f570b.svg";